import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Banner, { BannerColor, BannerType } from '@divvy-web/skylab.banner'

import styles from './styles.module.scss'

interface StatusBannerProps {
  bannerType: BannerType.Informative | BannerType.Warning | BannerType.Error | BannerType.Success
  title: ReactNode
  subtext: ReactNode
}

const getBackgroundColor = (type: BannerType) => {
  switch (type) {
    case BannerType.Informative:
      return BannerColor.Info
    case BannerType.Warning:
      return BannerColor.Warning
    case BannerType.Error:
      return BannerColor.Danger
    case BannerType.Success:
      return BannerColor.Success
  }
}

const StatusBanner = ({ bannerType, title, subtext }: StatusBannerProps) => {
  const [getClassName] = useNameFormatter('StatusBanner')

  return (
    <div className={styles[getClassName('')]}>
      <Banner
        backgroundColor={getBackgroundColor(bannerType)}
        bannerType={bannerType}
        messageContent={<div className={styles[getClassName('subtext')]}>{subtext}</div>}
        titleText={title}
      />
    </div>
  )
}
export default StatusBanner
